<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="upgradeManager-modal">
<!-- <div class="modal-content upgradeManager-modal"> -->
    <p-confirmDialog key="cd" #cd>
        <ng-template #footer>
          <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
          <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </ng-template>
    </p-confirmDialog>

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Gateway Update Manager</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body">
        <tabset>
            <tab heading="Manage Update Bundles" active="true" class="tabset">
                <div *ngIf="!loadingUpdateBundleFileList; else loading">
                    <input type="file" id="file" accept=".zip" (change)="bundleSelectedForUpload($event.target.files)" style="margin: 15px; width: 700px;">
                    <button type="button" class="btn btn-primary" style="float: right; margin-left: 15px;" (click)="startDeployingUpdateBundle()">Upload Bundle</button>

                    <p-table #bundleTable [columns]="updateBundleCols" [value]="updateBundles" [scrollable]="true" scrollHeight="20em" class="data-table-device">
                        <ng-template pTemplate="caption">
                            <div style="text-align: left; height: 50px; display: flex; align-items: center; ">
                                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                                <input type="text" pInputText size="35" placeholder="Search" (input)="bundleTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 30px">
                            </div>
                        </ng-template>

                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                            <tr style="height: 40px;">
                                <td [ngStyle]="{'width': columns[0].width}" style="cursor: pointer; flex: none; border-width: 0px;">
                                    {{ rowData.name }}
                                </td>

                                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.uploadDate | date : 'medium' }}
                                </td>
                                
                                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                    <div class="fa-solid fa-cloud-arrow-down"
                                        style="color: blue; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="onFileDownload(rowData) ">
                                    </div>
                                </td>

                                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                    <div class="far fa-trash-alt text-center"
                                        style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="onFileDeleteConfirm(rowData) ">
                                    </div>
                                </td>

                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </tab>

            <tab heading="Deploy Update Bundle" active="true" class="tabset">
                <div style="display: flex; margin-top: 15px; margin-bottom: 15px;">
                    <div class="form-group" style="width: 500px; height: 38px;">
                        <label>Update Bundle</label>
                        <ngx-select-dropdown
                            [multiple]=false
                            [(ngModel)]="selectedUpdateBundle"
                            [config]="bundleDropDownSettings"
                            [options]="updateBundles">
                        </ngx-select-dropdown>
                    </div>
                    <button type="button" class="btn btn-primary" style="margin-left: 15px; height: 38px; margin-top: 22px;" (click)="startDeployingUpdateBundle()" [disabled]="selectedUpdateBundle == undefined || selectedUpdateBundle.name == undefined || numberOfDevicesSelected < 1">Start Update</button>
                </div>

                <p-table #pushUpdateTable [columns]="pushUpdateCols" [value]="devices" [scrollable]="true" scrollHeight="20em" class="data-table-device">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; height: 40px; display: flex; align-items: center; ">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="35" placeholder="Search" (input)="pushUpdateTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 30px">
                            <label style="margin-left: 20px; font-size: 15px;">Selected Gateways:  {{ numberOfDevicesSelected }}</label>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                        <tr style="height: 40px;">
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                <p-checkbox id="{{rowData.id}}" name="{{rowData.id}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="deviceSelected(rowData)"></p-checkbox>
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="cursor: pointer; flex: none; border-width: 0px;">
                                <div (click)="setActiveGateway(rowData)" aria-hidden="true" style="cursor: pointer;">
                                    {{ rowData.name }}
                                </div>
                                
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                <div *ngIf="rowData.version === 'checking'" style="font-size: 14px;" class="fa fa-spinner fa-spin fa-1x fa-fw"></div>
                                <div *ngIf="rowData.version != 'checking'">{{ rowData.version }}</div>
                            </td>

                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.lastUpdateMessage }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div *ngIf="activeGateway != undefined && activeGateway.updateMessages != undefined" style="border: 1px dotted lightgray; height: 15em; overflow-y: scroll; font-size: 15px; margin-top: 15px; white-space: pre-wrap;">
                    <div style="font-size: 15px; margin-bottom: 5px; font-weight: 500; font-size: 14px;">Recent update logs for gateway -> {{activeGateway.name}}</div>
                    <div *ngFor="let update of activeGateway.updateMessages" style="font-size: 14px;">{{update.createdDate | date : 'medium' }}: &nbsp; &nbsp; {{update.message}}</div>
                </div>
                
            </tab>
        </tabset>
    </div>
</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 20px;"></i>
      <span>Loading ...</span>
    </div>
</ng-template>